module.exports = __webpack_public_path__ + "img/magazine-order-info.aa4e521f.png";